export var TransitionMethod;
(function (TransitionMethod) {
    TransitionMethod["INITIAL"] = "initial";
    TransitionMethod["REASSESSMENT_JUMP"] = "reassessment_jump";
    TransitionMethod["NORMAL_NAVIGATION"] = "normal_navigation";
    TransitionMethod["FORCE_PROCEED"] = "force_proceed";
    TransitionMethod["JUMP_TO"] = "jump_to";
})(TransitionMethod || (TransitionMethod = {}));
//# sourceMappingURL=types.js.map